import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService, NbIconConfig, NbToastrService } from '@nebular/theme';
import { VisorFirebaseService } from 'app/services/visor-firebase.service';
import { LocalDataSource } from 'ng2-smart-table';
import {MachineryCellEditorComponent} from './../../components/item-cell-editor/machinery-cell-editor.component';
import {AdvisorsAppliersCellEditorComponent} from './../../components/item-cell-editor/advisorsappliers-cell-editor.component';
import {CategoryAdvisorsAppliersCellEditorComponent} from './../../components/item-cell-editor/categoryadvisorsappliers-cell-editor.component';
import { ItemCellRenderComponent } from 'app/components/item-cell-editor/item-cell-render.component';
@Component({
  selector: 'ngx-explotacion',
  templateUrl: './explotacion.component.html',
  styleUrls: ['./explotacion.component.scss']
})
export class ExplotacionComponent implements OnInit {

  @ViewChild('addconfirmation')
  private AddDialog: TemplateRef<any>;
  @ViewChild('messageconfirmation')
  private MessageDialog: TemplateRef<any>;

  message = ""
  email = ""

  currentSeason = ""
  showInput: boolean = false;
  newSeasonName: string = '';
  newSeasonFechaInicio: Date = new Date();
  showErrorMessage: boolean = false;
  showErrorDateMessage: boolean = false;
  inputValue = '';
  groupAdmin: boolean = false;
  listUsers: any[] = [];

  constructor(protected visorFirebaseService: VisorFirebaseService,
    private route: ActivatedRoute,
    private router: Router,
    private nbToastr: NbToastrService,
    private dialogService: NbDialogService) { }

  ngOnInit(): void {

    this.visorFirebaseService.getUser().subscribe((user) =>{
      this.visorFirebaseService.obtenerMaquinaria().subscribe(d => {
        this.machineryTableSource.load(d);
      });

      this.visorFirebaseService.obtenerAsesoresAplicadores().subscribe(d => {
        this.advisorsappliersTableSource.load(d);
      });
      this.cargarTemporadaActual();

      this.visorFirebaseService.obtenerGroupAdministrator().subscribe((groupAdmin) => {
        console.log('Group Administrator:', groupAdmin);
        this.groupAdmin = groupAdmin;
        if(null != groupAdmin) this.obtenerLista();
        this.message = "";
      });

    });



  }

  tractorIcon: NbIconConfig = {    icon:'tractor', pack:'font-awesome'};

  userIcon: NbIconConfig = {    icon:'users', pack:'font-awesome'};

  machinery: [any];

  machineryTableSource: LocalDataSource = new LocalDataSource();

  machineryTableSettings = {
    attr:{
      id:'tabla-maquinaria',
    },
    actions: {
      delete: true,
      add: true,
      edit:true,
      position: 'right',
      columnTitle: 'Acciones',
  },

    add: {
      addButtonContent: '<i class="fas fa-plus"></i>',
      createButtonContent: '<i class="fas fa-check-square"></i>',
      cancelButtonContent: '<i class="fas fa-window-close"></i>',
      confirmCreate:true,
    },
    edit: {
      editButtonContent: '<i class="fas fa-edit"></i>',
      saveButtonContent: '<i class="fas fa-check-square"></i>',
      cancelButtonContent: '<i class="fas fa-window-close"></i>',
      confirmSave:true,
    },
    delete: {
      deleteButtonContent: '<i class="fas fa-trash-alt"></i>',
      confirmDelete: true,
    },
    pager:{
      display:true,
    },

    columns: {
      registro: {
        title: 'Registro',
        type: 'string',
      },
      nombre: {
        title: 'Nombre',
        type: 'string',
      },
      tipo: {
        title: 'Tipo',
        type: 'custom',
        editor: {
          type: 'custom',
          component: MachineryCellEditorComponent,
        },
        renderComponent: ItemCellRenderComponent
      }
    }
  }

  advisorsappliers: [any];

  advisorsappliersTableSource: LocalDataSource = new LocalDataSource();

  advisorsappliersTableSettings = {
    attr:{
      id:'tabla-asesoresaplicadores',
    },
    actions: {
      delete: true,
      add: true,
      edit:true,
      position: 'right',
      columnTitle: 'Acciones',
  },

    add: {
      addButtonContent: '<i class="fas fa-plus"></i>',
      createButtonContent: '<i class="fas fa-check-square"></i>',
      cancelButtonContent: '<i class="fas fa-window-close"></i>',
      confirmCreate:true,
    },
    edit: {
      editButtonContent: '<i class="fas fa-edit"></i>',
      saveButtonContent: '<i class="fas fa-check-square"></i>',
      cancelButtonContent: '<i class="fas fa-window-close"></i>',
      confirmSave:true,
    },
    delete: {
      deleteButtonContent: '<i class="fas fa-trash-alt"></i>',
      confirmDelete: true,
    },
    pager:{
      display:true,
    },

    columns: {
      registro: {
        title: 'Registro',
        type: 'string',
      },
      nombre: {
        title: 'Nombre',
        type: 'string',
      },
      categoria: {
        title: 'Categoría',
        type: 'custom',
        editor: {
          type: 'custom',
          component: CategoryAdvisorsAppliersCellEditorComponent,
        },
        renderComponent: ItemCellRenderComponent
      },
      tipo: {
        title: 'Tipo',
        type: 'custom',
        editor: {
          type: 'custom',
          component: AdvisorsAppliersCellEditorComponent,
        },
        renderComponent: ItemCellRenderComponent
      }
    }
  }

  usersAdministrated: [any];

  usersAdministratedTableSource: LocalDataSource = new LocalDataSource();

  usersAdministratedTableSettings = {
    attr:{
      id:'tabla-usersadministrated',
    },
    actions: {
      delete: false,
      add: false,
      edit:false,
      position: 'right',
      columnTitle: 'Invita usuario',
  },
    pager:{
      display:true,
    },

    columns: {
      email: {
        title: 'Email',
        type: 'string',
        width: '70%'
      },
      estado: {
        title: 'Estado',
        type: 'string',
        width: '30%'
      }
    }
  }

 async editarMaquinaria(event){

    let data2save = JSON.parse(JSON.stringify(event.newData))

    await this.visorFirebaseService.guardarMaquinaria(data2save);
    await event.confirm.resolve(event.newData);
  }

  async crearMaquinaria(event){
    let data2save = JSON.parse(JSON.stringify(event.newData));

    let newdata = await this.visorFirebaseService.guardarMaquinaria(data2save);
    await event.confirm.resolve(newdata);
  }

  async eliminarMaquinaria(event){
      await this.visorFirebaseService.eliminarMaquinaria(event.data.identifier);
      event.confirm.resolve();
  }

  async editarAsesoresAplicadores(event){

    let data2save = JSON.parse(JSON.stringify(event.newData));

    await this.visorFirebaseService.guardarAsesoresAplicadores(data2save);
    await event.confirm.resolve(event.newData);
  }

  async crearAsesoresAplicadores(event){
    let data2save = JSON.parse(JSON.stringify(event.newData));

    let newdata = await this.visorFirebaseService.guardarAsesoresAplicadores(data2save);
    await event.confirm.resolve(newdata);
  }

  async eliminarAsesoresAplicadores(event){
      await this.visorFirebaseService.eliminarAsesoresAplicadores(event.data.identifier);
      event.confirm.resolve();
  }

  cargarTemporadaActual(){
    this.visorFirebaseService.obtenerCurrentSeason().subscribe(season => this.currentSeason = season);
  }

  onAccept() {

    // Validar si se ha introducido el nombre
    this.showErrorMessage = false;
    this.showErrorDateMessage = false;

    if (this.newSeasonName ==null || this.newSeasonName.trim() === '') {
      this.showErrorMessage = true;
    } else {
      if (this.inputValue != '') {
        if (!(this.newSeasonFechaInicio instanceof Date)) {
          this.showErrorDateMessage = true;
        }
      }
    }

    if (!this.showErrorMessage && !this.showErrorDateMessage) {
      this.visorFirebaseService.newSeason(this.newSeasonName, this.newSeasonFechaInicio);
      console.log('Campaña creada');
      this.showErrorMessage = false;
      this.showInput = false;
      this.currentSeason = this.newSeasonName
    }
  }

  onCancel() {
    this.newSeasonName = '';
    this.newSeasonFechaInicio = new Date();
    this.showInput = false;
    this.showErrorMessage = false;
    this.showErrorDateMessage = false;
  }

  inicializa() {
    this.newSeasonName = '';
    this.newSeasonFechaInicio = new Date();
    this.showInput = true;
    this.showErrorMessage = false;
    this.showErrorDateMessage = false;
  }

  // Método para manejar la entrada manual de la fecha
  handleDateInput(event: any) {
    this.inputValue = event.target.value;
    if (this.inputValue != '') {
      const parsedDate = this.parseDate(this.inputValue);  // Intentamos convertir la fecha manualmente
      if (parsedDate) {
        this.newSeasonFechaInicio = parsedDate;  // Si es válida, asignamos la fecha
        this.showErrorDateMessage = false;  // Ocultamos el mensaje de error
      } else {
        this.newSeasonFechaInicio = null;  // Si no es válida, mantenemos null
        this.showErrorDateMessage = true;  // Mostramos el mensaje de error
      }
    }
  }

  // Función para convertir una fecha en formato dd/MM/yyyy en un objeto Date
  parseDate(dateString: string): Date | null {
    const dateParts = dateString.split('/');

    // Verificamos que haya 3 partes y que cada una tenga la longitud adecuada
    if (dateParts.length === 3 &&
        dateParts[0].length === 2 &&  // Día debe tener 2 dígitos
        dateParts[1].length === 2 &&  // Mes debe tener 2 dígitos
        dateParts[2].length === 4) {  // Año debe tener 4 dígitos

      const day = Number(dateParts[0]);
      const month = Number(dateParts[1]) - 1;  // Los meses en JS van de 0 a 11
      const year = Number(dateParts[2]);

      const date = new Date(year, month, day);

      // Verificamos si la fecha es válida comparando los componentes
      if (date.getFullYear() === year && date.getMonth() === month && date.getDate() === day) {
        return date;
      }
    }

    return null;  // Si la fecha es inválida o el formato no es correcto, devolvemos null
  }

// Mostrar el cuadro de diálogo para añadir un usuario
showAddUserAlert() {
  this.dialogService.open(this.AddDialog);
}
enviarEmailVerificacion(email: string): void {
  this.addUser(email);
  this.email = '';
}
deleteMessage(): void {
  this.message = "";
}

// Añadir un usuario por email
addUser(email: string) {
  this.visorFirebaseService.fetchUserByEmail(email).subscribe(
    ({ user, situacion }) => {
      this.handleAddUserResponse(user, situacion);
    },
    (error) => {
      console.error('Error al añadir usuario:', error);
    }
  );
}

handleAddUserResponse(user: any, situacion: string) {
  switch (situacion) {
    case 'No encontrado':
      this.message = 'El email introducido no corresponde a ningún usuario.';
      break;
    case 'Existe':
      this.message = 'El email introducido ya está en la lista.';
      break;
    case 'Administrador':
      this.message = 'El email introducido corresponde a un administrador.';
      break;
    case 'Alta':
      this.visorFirebaseService.updateUser(user)
        .then(() => {
          // Recarga la lista después de la actualización
          return this.obtenerLista();
        })
        .then(() => {
          this.message = 'El email introducido ha sido añadido a la lista.';
        })
        .catch((error) => {
          console.error('Error al guardar el registro:', error);
          this.message = 'Ocurrió un error al añadir el usuario a la lista. Intente nuevamente.';
        });
      break;
    default:
      this.message = 'Ocurrió un error desconocido.';
      break;
  }

  if (this.message.trim()) {
    this.dialogService.open(this.MessageDialog);
  }
}


obtenerLista() {
  this.visorFirebaseService.obtenerUsersAdministrated().subscribe(
    (d) => {
      console.log('Group Administrator d:', d);
      this.usersAdministratedTableSource.load(d);
    },
    (error) => {
      console.error('Error al obtener usuarios administrados:', error);
    }
  );
}
}
